import { useFormContext } from "react-hook-form";

import {
  PriorClaimsQuestion,
  QuestionType,
} from "@covertree/new-business-graphql";
import {
  FormCheckbox,
  FormCurrencyField,
  FormDateField,
  FormSelectField,
} from "@covertree/ui";
import {
  PriorClaimsForm,
  mapPriorClaimCategoryToFormattedClaimCategory,
} from "@covertree/new-business-forms";

interface PriorClaimQuestionContentProps {
  question: PriorClaimsQuestion;
  claimIndex: number;
  disabled?: boolean;
}

export function PriorClaimQuestionContent({
  question: { type, fieldName, label, options },
  claimIndex,
  disabled,
}: PriorClaimQuestionContentProps) {
  const { control } = useFormContext<PriorClaimsForm>();

  if (type === QuestionType.Dropdown)
    return (
      <FormSelectField
        id={`claimItem-${claimIndex}-${fieldName}`}
        name={`claims.${claimIndex}.${fieldName}`}
        control={control}
        options={Object.values(options).map((val) => ({
          label: mapPriorClaimCategoryToFormattedClaimCategory(val),
          value: mapPriorClaimCategoryToFormattedClaimCategory(val),
        }))}
        label={label}
        disabled={disabled}
      />
    );

  if (type === QuestionType.Amount)
    return (
      <FormCurrencyField
        id={`claimItem-${claimIndex}-${fieldName}`}
        name={`claims.${claimIndex}.${fieldName}`}
        control={control}
        label={label}
        disabled={disabled}
      />
    );

  if (type === QuestionType.Date)
    return (
      <FormDateField
        id={`claimItem-${claimIndex}-${fieldName}`}
        name={`claims.${claimIndex}.${fieldName}`}
        control={control}
        label={label}
        disabled={disabled}
      />
    );

  if (type === QuestionType.Checkbox)
    return (
      <FormCheckbox
        id={`claimItem-${claimIndex}-${fieldName}`}
        name={`claims.${claimIndex}.${fieldName}`}
        control={control}
        label={label}
        disabled={disabled}
      />
    );
}
